//outsource
import { Row, Col, Radio, Typography, Calendar } from "antd";
import moment from "moment";
import XmasIcon from "../../../../../asset/img/xmas.png";
//string
import { NORMAL_DAYS26 } from "../../../../../store/data/booking";
import { AVAILABLE_TIME } from "../../../../../store/data/group";

//holidays
const holiday = {
  xmas: "25/12/2023",
  newyear: "01/01/2024",
  anzac: "25/04/2024",
};

//xmas days

const xmasday = ["25/12/2023"];

const { Text } = Typography;

const SelectFullDate = ({ full, setFull }) => {
  // -------------------------- VAR --------------------------
  const avail = AVAILABLE_TIME;
  const date = full?.date && moment(full?.date, "DD/MM/YYYY");
  // const dateString = date && date.format("DD/MM/YYYY");

  //detect sunday
  const detected = date.format("dd");
  console.log({ detected });

  // const dataSource =
  //   detected === "Su"
  //     ? NORMAL_SUNDAY
  //     : detected === "Sa"
  //     ? NORMAL_SARTUDAY
  //     : NORMAL_DAYS26;

  //detect xmas
  // const xmasDetected = prexmas?.includes(dateString) || false;
  // const dataSourceXmas = detected === "Su" ? XMAS_SUNDAY : XMAS_DAILY;

  // const targetData = xmasDetected ? dataSourceXmas : dataSource;

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const onSelect = (value) => {
    const date = moment(value.toDate()).format("DD/MM/YYYY");
    setFull((full) => {
      return {
        ...full,
        date,
      };
    });
  };

  const handleChange = (e) => {
    setFull((full) => {
      return {
        ...full,
        time: e.target.value,
      };
    });
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  const renderArrivalTime = () => {
    return (
      <Row style={{ marginTop: "2rem" }} gutter={[5]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <h2 style={{ fontSize: "20px" }} className="title-time">
            Available Time:
          </h2>
        </Col>
        {renderNormalDays()}
      </Row>
    );
  };

  const renderNormalDays = () => {
    return (
      <Radio.Group
        style={{ width: "100%", margin: "-1rem 0 0 1.5rem" }}
        value={full?.time}
        onChange={handleChange}
      >
        {avail.map((item) => (
          <Col key={item} span={24} style={{ margin: "0.8rem 0" }}>
            <Radio value={item}>{item}</Radio>
          </Col>
        ))}
      </Radio.Group>
    );
  };

  const getCellRender = (value) => {
    const cellString = value?.format("DD/MM/YYYY");
    const validsCell = xmasday?.includes(cellString) || false;
    if (validsCell) {
      return <img src={XmasIcon} style={{ width: 30 }} alt="icon" />;
    }
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Calendar
        className="calender-booking"
        fullscreen={false}
        onSelect={onSelect}
        value={date}
        dateCellRender={getCellRender}
        disabledDate={(current) => {
          // disabled normal days
          const now = moment();
          const prev = moment().subtract(1, "days");
          const max = moment(
            NORMAL_DAYS26.AFTERNOON[NORMAL_DAYS26.AFTERNOON?.length],
            "hh:mm A"
          );

          //disabled holiday
          const dateString = current?.format("DD/MM/YYYY");
          const validHoliday = dateString === holiday?.anzac || false;

          const validDisabled = now.isAfter(max)
            ? current.isBefore(now)
            : current.isBefore(prev);

          return validDisabled || validHoliday;
        }}
      />
      {renderArrivalTime()}
    </>
  );
};

export default SelectFullDate;
